var _rect, _style, _text, _text2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinalHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 740,
    height: 520,
    viewBox: "0 0 740 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "none"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "text{font-family:\"Noto Serif Georgian\",\"Noto Sans Georgian\",Georgia,serif; font-weight:800; fill:#000; letter-spacing:-1px;}")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 370,
    y: 105,
    fontSize: 72,
    textAnchor: "middle",
    transform: "rotate(-3 370 105)"
  }, "\u10E8\u10D4\u10DC\u10EA \u10D8\u10DE\u10DD\u10D5\u10D4")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 370,
    y: 275,
    fontSize: 86,
    textAnchor: "middle",
    transform: "rotate(1 370 275)"
  }, "\u10E8\u10D4\u10DC\u10D8 \u10D2\u10D0\u10DC\u10EB\u10D8!")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210 400 C300 425, 395 418, 470 390",
    fill: "none",
    stroke: "#d9b847",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M460 390 L430 374 M460 390 L435 413",
    fill: "none",
    stroke: "#d9b847",
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalHover);
export default __webpack_public_path__ + "static/media/final-hover.9184569093d708ac202199298a979c32.svg";
export { ForwardRef as ReactComponent };